import { Component, OnInit, Inject, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/shared/Notification.service';

import { DanhMucThanhVien } from 'src/app/shared/DanhMucThanhVien.model';
import { DanhMucThanhVienService } from 'src/app/shared/DanhMucThanhVien.service';
import { DanhMucChucDanh } from 'src/app/shared/DanhMucChucDanh.model';
import { DanhMucChucDanhService } from 'src/app/shared/DanhMucChucDanh.service';
import { AgencyDepartment } from 'src/app/shared/AgencyDepartment.model';
import { AgencyDepartmentService } from 'src/app/shared/AgencyDepartment.service';
import { StateAgency } from 'src/app/shared/StateAgency.model';
import { StateAgencyService } from 'src/app/shared/StateAgency.service';

import { ThanhVien } from 'src/app/shared/ThanhVien.model';
import { ThanhVienService } from 'src/app/shared/ThanhVien.service';
import { ThanhVienPhanQuyenChucNang } from 'src/app/shared/ThanhVienPhanQuyenChucNang.model';
import { ThanhVienPhanQuyenChucNangService } from 'src/app/shared/ThanhVienPhanQuyenChucNang.service';

import { CompanyInfo } from 'src/app/shared/CompanyInfo.model';
import { CompanyInfoService } from 'src/app/shared/CompanyInfo.service';

@Component({
  selector: 'app-thanh-vien-detail',
  templateUrl: './thanh-vien-detail.component.html',
  styleUrls: ['./thanh-vien-detail.component.css']
})
export class ThanhVienDetailComponent implements OnInit {

  @ViewChild('ThanhVienPhanQuyenChucNangSort') ThanhVienPhanQuyenChucNangSort: MatSort;
  @ViewChild('ThanhVienPhanQuyenChucNangPaginator') ThanhVienPhanQuyenChucNangPaginator: MatPaginator;
  @ViewChild('search') searchElement: ElementRef;

  MatKhauIsActive: boolean = true;

  ActiveAllThanhVienPhanQuyenChucNang: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ThanhVienDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    public NotificationService: NotificationService,

    public DanhMucThanhVienService: DanhMucThanhVienService,
    public DanhMucChucDanhService: DanhMucChucDanhService,
    public AgencyDepartmentService: AgencyDepartmentService,
    public StateAgencyService: StateAgencyService,

    public ThanhVienService: ThanhVienService,
    public ThanhVienPhanQuyenChucNangService: ThanhVienPhanQuyenChucNangService,

    public CompanyInfoService: CompanyInfoService,
    private cdRef: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.ThanhVienService.FormData = new ThanhVien();
    this.ThanhVienGetByID();
  }

  countLoading = 0;
  StopLoading(){
    this.countLoading--;
    setTimeout(()=>{
      if(this.countLoading == 0){
        this.ThanhVienService.IsShowLoading = false;
      }
    },1000);
  }
  StartLoading(){
    if(this.countLoading == 0){
      this.ThanhVienService.IsShowLoading = true;
    }
    this.countLoading++;
  }

  MatKhauChangeType() {
    this.MatKhauIsActive = !this.MatKhauIsActive;
  }

  SearchForCompany(){
    this.CompanyInfoFilter(this.companyInfoSearch);
  }
  companyInfoSearch: string
  companyInfo: CompanyInfo = new CompanyInfo()
  CompanyInfoSearch() {
    this.CompanyInfoService.BaseParameter.ID = this.ThanhVienService.FormData.CompanyInfoID;
    this.CompanyInfoService.ComponentGet000ToListAsync();
  }
  RemoveMemberFromGroup(){
    this.companyInfo= new CompanyInfo()
    this.ThanhVienService.FormData.CompanyInfoID = 0
  }

    // this.CompanyInfoService.BaseParameter.SearchString = this.searchCompany;
    // this.CompanyInfoService.BaseParameter.Active = true;
    // this.CompanyInfoService.GetByActive_SearchStringToListAsync().subscribe(
    //   (res: any[]) => {
    //     this.CompanyInfoService.list = res;
    //     this.isShowLoading = false;
    //     setTimeout(() => {
    //       this.initializeSelect();
    //       this.cdRef.detectChanges();
    //     });
    //   },
    //   (err) => {
    //     console.error('API error:', err);
    //     this.isShowLoading = false;
    //   }
    // );
  async CompanyInfoFilter(searchString: string) {
    if(searchString.trim() === "")
      return;
    this.CompanyInfoService.BaseParameter.ID = this.ThanhVienService.FormData.CompanyInfoID;
    if(this.CompanyInfoService.BaseParameter.ID === null){
      this.CompanyInfoService.BaseParameter.ID = 0
    }
    this.StartLoading();
    this.CompanyInfoService.BaseParameter.SearchString = searchString;
    this.CompanyInfoService.BaseParameter.Active = true;
    this.CompanyInfoService.GetByActive_SearchStringToListAsync().subscribe(
      res => {
        this.StopLoading();
        this.companyInfo = (res as CompanyInfo[])[0]
        if(this.companyInfo===undefined)
          this.NotificationService.warn(environment.KhongTimThay);
        else{
          this.ThanhVienService.FormData.CompanyInfoID = this.companyInfo.ID
          this.companyInfoSearch = ""
          // setTimeout(()=>{
          //   this.searchElement.nativeElement.blur();
          // },0);
        }
      },
      err => {
        this.StopLoading();
        this.companyInfoSearch = ""
      }
    );
    
  }
  async StateAgencyChange(StateAgencyID:number){
    await this.AgencyDepartmentSearch()
    this.AgencyDepartmentService.List = this.AgencyDepartmentService.List.filter(item => item.ParentID == StateAgencyID)
  }
  
  async DanhMucThanhVienSearch(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.DanhMucThanhVienService.List && this.DanhMucThanhVienService.List.length > 0) {
        resolve();
        return;
      }
      
      this.DanhMucThanhVienService.GetByCompanyInfoThanhVienToListAsync().subscribe(
        res => {
          this.DanhMucThanhVienService.List = (res as ThanhVien[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
          resolve();
        },
        err => {
          reject(err);
        }
      );
    });
  }
  
  async DanhMucChucDanhSearch(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.DanhMucChucDanhService.ComponentGetAllToListAsyncUpdate().subscribe(
        res => {
          resolve();
        },
        err => {
          reject(err);
        }
      );
    });
  }
  async AgencyDepartmentSearch(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.AgencyDepartmentService.ComponentGetAllToListAsyncUpdate().subscribe(
        res => {
          resolve();
        },
        err => {
          reject(err);
        }
      );
    });
  }
  async StateAgencySearch(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.StateAgencyService.ComponentGetAllToListAsyncUpdate().subscribe(
        res => {
          resolve();
        },
        err => {
          reject(err);
        }
      );
    });
  }
  ThanhVienGetByID() {
    if (this.ThanhVienService.FormData) {
      this.ThanhVienService.FormData = new ThanhVien();
    }
    this.StartLoading();
    this.ThanhVienService.GetByIDAsync().subscribe(
      async res => {
        const promises = [
          this.DanhMucThanhVienSearch(),
          this.DanhMucChucDanhSearch(),
          this.AgencyDepartmentSearch(),
          this.StateAgencySearch()
        ];
        try {
          await Promise.all(promises);
          this.StopLoading();
          this.ThanhVienService.FormData = res as ThanhVien;
          
          this.cdRef.detectChanges();
          
          if(this.ThanhVienService.FormData.StateAgencyID == null) {
            this.AgencyDepartmentService.List = []
          } else {
            this.AgencyDepartmentService.List = this.AgencyDepartmentService.List.filter(item => 
              item.ParentID == this.ThanhVienService.FormData.StateAgencyID)
          }
          if(this.ThanhVienService.FormData.CompanyInfoID!==null)
            this.CompanyInfoFilter(this.ThanhVienService.FormData.CompanyInfoID+"")
          this.ThanhVienPhanQuyenChucNangSearch();
        } catch (error) {
          this.StopLoading();
        }
      },
      err => {
        this.StopLoading();
      }
    );
  }

  ThanhVienSave() {
    // Chặn save trên mobile
    if (this.NotificationService.blockMobileActionIfNeeded()) {
      return;
    }
    
    this.StartLoading();
    this.ThanhVienService.SaveAsync().subscribe(
      res => {
        this.ThanhVienService.FormData = res as ThanhVien;
        this.StopLoading();
        this.NotificationService.warn(environment.SaveSuccess);
      },
      err => {
        this.StopLoading();
        this.NotificationService.warn(environment.SaveNotSuccess);
      }
    );
  }



  ThanhVienPhanQuyenChucNangSearch() {
    if (this.ThanhVienPhanQuyenChucNangService.BaseParameter.SearchString.length > 0) {
      this.ThanhVienPhanQuyenChucNangService.DataSource.filter = this.ThanhVienPhanQuyenChucNangService.BaseParameter.SearchString.toLowerCase();
    }
    else {
      this.ThanhVienPhanQuyenChucNangGetToList();
    }
  }

  ThanhVienPhanQuyenChucNangGetToList() {
    this.StartLoading();
    this.ThanhVienPhanQuyenChucNangService.BaseParameter.ParentID = this.ThanhVienService.FormData.ID;
    this.ThanhVienPhanQuyenChucNangService.GetSQLByParentIDToListAsync().subscribe(
      res => {
        this.StopLoading();
        this.ThanhVienPhanQuyenChucNangService.List = (res as ThanhVienPhanQuyenChucNang[]);
        this.ThanhVienPhanQuyenChucNangService.DataSource = new MatTableDataSource(this.ThanhVienPhanQuyenChucNangService.List);
        this.ThanhVienPhanQuyenChucNangService.DataSource.sort = this.ThanhVienPhanQuyenChucNangSort;
        this.ThanhVienPhanQuyenChucNangService.DataSource.paginator = this.ThanhVienPhanQuyenChucNangPaginator;
      },
      err => {
        this.StopLoading();
      }
    );
  }

  ThanhVienPhanQuyenChucNangActiveChange(element: ThanhVienPhanQuyenChucNang) {
    this.StartLoading();
    this.ThanhVienPhanQuyenChucNangService.FormData = element;
    this.ThanhVienPhanQuyenChucNangService.FormData.ParentID = this.ThanhVienService.FormData.ID;
    this.ThanhVienPhanQuyenChucNangService.SaveAsync().subscribe(
      res => {
        this.NotificationService.warn(environment.SaveSuccess);
        this.StopLoading();
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.StopLoading();
      }
    );
  }
  ThanhVienPhanQuyenChucNangActiveAllChange() {
    this.StartLoading();
    for (let i = 0; i < this.ThanhVienPhanQuyenChucNangService.List.length; i++) {
      this.ThanhVienPhanQuyenChucNangService.FormData = this.ThanhVienPhanQuyenChucNangService.List[i];
      this.ThanhVienPhanQuyenChucNangService.FormData.ParentID = this.ThanhVienService.FormData.ID;
      this.ThanhVienPhanQuyenChucNangService.FormData.Active = this.ActiveAllThanhVienPhanQuyenChucNang;
    }
    this.ThanhVienPhanQuyenChucNangService.SaveListAsync(this.ThanhVienPhanQuyenChucNangService.List).subscribe(
      res => {
        this.ThanhVienPhanQuyenChucNangSearch();
        this.NotificationService.warn(environment.SaveSuccess);
          this.StopLoading();
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.StopLoading();
      }
    );
  }

  Close() {
    this.dialogRef.close();
  }

}
